import { render, staticRenderFns } from "./editDialog.vue?vue&type=template&id=02f4ff2f&scoped=true"
import script from "./editDialog.vue?vue&type=script&lang=js"
export * from "./editDialog.vue?vue&type=script&lang=js"
import style0 from "./editDialog.vue?vue&type=style&index=0&id=02f4ff2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f4ff2f",
  null
  
)

export default component.exports